import React, { useEffect, useRef, useState } from 'react';
import { apiGet, apiUpload } from '../../api/client';

export default function MediaPicker({ label, value, onChange, placeholder }) {
  const [open, setOpen] = useState(false);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const fileRef = useRef(null);

  const loadLibrary = async () => {
    setLoading(true);
    setError('');
    try {
      const data = await apiGet('/admin/media?limit=200');
      setItems(data.items || []);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open) {
      loadLibrary();
    }
  }, [open]);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setError('');
    try {
      const formData = new FormData();
      formData.append('file', file);
      const item = await apiUpload('/admin/media', formData);
      onChange(item.url);
      if (open) {
        setItems((prev) => [item, ...prev]);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      e.target.value = '';
    }
  };

  return (
    <div className="admin-media-picker">
      {label && <span className="admin-media-picker__label">{label}</span>}
      <div className="admin-media-picker__row">
        <input
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
        />
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => setOpen(true)}>
          Library
        </button>
        <button type="button" className="btn btn-secondary btn-sm" onClick={() => fileRef.current?.click()}>
          Upload
        </button>
        <input ref={fileRef} type="file" accept="image/jpeg,image/png,image/webp,image/gif" hidden onChange={handleUpload} />
      </div>
      {value && (
        <div className="admin-media-picker__preview">
          <img src={value} alt="" />
        </div>
      )}
      {error && <p className="admin-message admin-message--error">{error}</p>}

      {open && (
        <div className="admin-media-modal" role="dialog" aria-modal="true" aria-label="Media library">
          <div className="admin-media-modal__backdrop" onClick={() => setOpen(false)} />
          <div className="admin-media-modal__panel">
            <div className="admin-media-modal__header">
              <h4>Media library</h4>
              <button type="button" className="admin-media-modal__close" onClick={() => setOpen(false)} aria-label="Close">
                <i className="fas fa-times" />
              </button>
            </div>
            <div className="admin-media-modal__toolbar">
              <button type="button" className="btn btn-primary btn-sm" onClick={() => fileRef.current?.click()}>
                Upload new
              </button>
            </div>
            {loading ? (
              <p>Loading…</p>
            ) : items.length === 0 ? (
              <p className="admin-media-modal__empty">No images yet. Upload one to get started.</p>
            ) : (
              <div className="admin-media-modal__grid">
                {items.map((item) => (
                  <button
                    key={item.id}
                    type="button"
                    className={`admin-media-modal__item${value === item.url ? ' is-selected' : ''}`}
                    onClick={() => {
                      onChange(item.url);
                      setOpen(false);
                    }}
                  >
                    <img src={item.url} alt={item.originalName} />
                    <span>{item.originalName}</span>
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
